// @arch:pure-engine
// Small, bounded draft store. Storage is injected so the engine stays testable
// and the browser implementation can be replaced by the future supervisor.

const KEY = 'apolo:new-chat-draft:v1';
const MAX_TEXT = 100_000;

function valid(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
}

export function readDraft(storage, scope = 'legacy') {
  if (!storage) return null;
  try {
    const parsed = JSON.parse(storage.getItem(`${KEY}:${scope}`) || 'null');
    return valid(parsed);
  } catch {
    return null;
  }
}

export function writeDraft(storage, draft = {}, scope = 'legacy') {
  if (!storage) return false;
  const payload = {
    text: String(draft.text || '').slice(0, MAX_TEXT),
    mode: draft.mode || 'chat',
    model: draft.model || null,
    scope: draft.scope || 'local',
    environment: draft.environment || 'direct',
    permissions_mode: draft.permissions_mode || 'ask',
    directory: draft.directory || null,
    github_repo: draft.github_repo || null,
    client_intent_id: draft.client_intent_id || null,
    skills: Array.isArray(draft.skills) ? draft.skills : [],
    updatedAt: Date.now(),
  };
  try {
    storage.setItem(`${KEY}:${scope}`, JSON.stringify(payload));
    return true;
  } catch {
    return false;
  }
}

export function clearDraft(storage, scope = 'legacy') {
  try { storage?.removeItem(`${KEY}:${scope}`); } catch { /* best effort */ }
}

export { KEY as NEW_CHAT_DRAFT_KEY };

export function listDrafts(storage, scope) {
  const prefix = `${KEY}:${scope}:archive:`;
  const drafts = [];
  try {
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (!key?.startsWith(prefix)) continue;
      try {
        const draft = valid(JSON.parse(storage.getItem(key)));
        if (draft) drafts.push(draft);
      } catch { /* isolate corruption to this entry */ }
    }
  } catch { /* malformed entry is never permission to discard other drafts */ }
  return drafts.sort((a, b) => b.updatedAt - a.updatedAt);
}
